import React from 'react'
import RMAP from '../assets/RMAP.png'
import NFIPSFS from '../assets/NFIPSFS.png'
import LMH from '../assets/LMH.png'
import FACL from '../assets/FACL.png'
import DSFS from '../assets/DSFS.png'
import FEMA from '../assets/FEMA.png'
import HMAG from '../assets/HMAG.png'
import EAPT from '../assets/EAPT.png'
import Riskmappdf from '../assets/GeneralFactSheets/riskmap_fact_sheet_05-11-10.pdf'
import NFIPpdf from '../assets/GeneralFactSheets/NFIP_Fact-Sheet_May-2016.pdf'
import LocalHazardpdf from '../assets/GeneralFactSheets/Local_Hazard_Mitigation_Planning_Fact_Sheet_Final_508.pdf'
import FloodPlainAdminpdf from '../assets/GeneralFactSheets/Floodplain_Administrators_Contact_List.pdf'
import DamSafetypdf from '../assets/GeneralFactSheets/Fact-DamSafety.pdf'
import IAProgrampdf from '../assets/GeneralFactSheets/FACTSHEET-IAProgram2016.pdf'
import HazardMitigationpdf from '../assets/GeneralFactSheets/Hazard_Mitigation_Assistance_Grants_fact-sheet.pdf'
import EmergencyActiondoc from '../assets/GeneralFactSheets/Emergency Action Plan Fillable Form-OWRB v3-NIMS.doc'

export default function AddiResource() {
    return (
        <div>
            <div className='container'>
                <div className="row">
                    <div className='col-1'></div>
                    <div className='col-10 px-5'>
                        <div className="row">
                            <div className="col" style={{ textAlign: "start", color: "#0066A8" }}>
                                <h2 className='fw-normal'>Additional Resources</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={Riskmappdf} target="_blank"><img
                                    src={RMAP} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={NFIPpdf} target="_blank"><img
                                    src={NFIPSFS} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={LocalHazardpdf}
                                    target="_blank"><img src={LMH} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={FloodPlainAdminpdf}
                                    target="_blank"><img src={FACL} style={{ maxWidth: "100%" }} /></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={DamSafetypdf} target="_blank"><img
                                    src={DSFS} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={IAProgrampdf} target="_blank"><img
                                    src={FEMA} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={HazardMitigationpdf}
                                    target="_blank"><img src={HMAG} style={{ maxWidth: "100%" }} /></a>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-md-6" style={{ padding: "5px" }}>
                                <a href={EmergencyActiondoc}
                                    target="_blank"><img src={EAPT} style={{ maxWidth: "100%" }} /></a>
                            </div>
                        </div>

                    </div>
                    <div className='col-1'></div>

                </div>

            </div>
        </div>
    )
}
